import { IQService } from "angular";
import { getExceptionMessage } from "../../core/data-utils";
import { EmploymentProcessingService } from "../../core/services";
import { NewHireVM, ProcessingState } from "./employment-processing-models";

export class NewHiresProcessor {
    constructor(private $q: IQService, private employmentProcessingService: EmploymentProcessingService) {
        'ngInject';
    }

    batchProcessNewHires(newHires: NewHireVM[]) {
        const chunkResult = newHires.reduce((processingResult, employee) => {
            employee.processingState = ProcessingState.Processing;
            const saved = this.employmentProcessingService.processNewHire(employee.EmployeeID, {
                ADPEmployeeID: employee.ADPEmployeeID,
                EmployeeID: employee.EmployeeID,
                FEIN: employee.FEIN,
                SSN: employee.SSN
            })
                .then(() => {
                    employee.processingState = ProcessingState.Processed;
                    employee.isSelected = false;
                    processingResult.succeeded++;
                })
                .catch(ex => {
                    employee.processingState = ProcessingState.Failed;
                    processingResult.failed++;
                    processingResult.messages.push(`failed to process ${employee.EmployeeID}: `
                        + getExceptionMessage(ex));
                });
            processingResult.promises.push(saved);
            return processingResult;
        }, { succeeded: 0, failed: 0, messages: [], promises: [] });
        return this.$q.all(chunkResult.promises)
            .then(() => chunkResult);
    }
}
